/**
 * Allowlisted workshop object types (spec: Core feature 7 — at least 12 authored reusable types,
 * decor plus interactive). Behaviour comes only from this catalogue and its typed props; worlds
 * never carry scripts or code (spec: Security requirement 7).
 *
 * Circuit types expose named terminals ("ports") that world connections (wires) attach to, so a
 * saved world maps directly onto the circuit engine graph in Phase 6/8.
 */

export const DECOR_COLOURS = ['natural', 'sky', 'leaf', 'sun', 'berry', 'slate'] as const;
export type DecorColour = (typeof DECOR_COLOURS)[number];

export const OBJECT_TYPES = {
  // Decor
  'floor-tile': { category: 'decor', ports: [] },
  'wall-panel': { category: 'decor', ports: [] },
  table: { category: 'decor', ports: [] },
  shelf: { category: 'decor', ports: [] },
  plant: { category: 'decor', ports: [] },
  rug: { category: 'decor', ports: [] },
  window: { category: 'decor', ports: [] },
  poster: { category: 'decor', ports: [] },
  // Interactive circuit components
  battery: { category: 'circuit', ports: ['positive', 'negative'] },
  switch: { category: 'circuit', ports: ['a', 'b'] },
  lamp: { category: 'circuit', ports: ['a', 'b'] },
  'light-sensor': { category: 'circuit', ports: ['in', 'out'] },
  fan: { category: 'circuit', ports: ['a', 'b'] },
} as const satisfies Record<string, { category: 'decor' | 'circuit'; ports: readonly string[] }>;

export type WorldObjectType = keyof typeof OBJECT_TYPES;
export const WORLD_OBJECT_TYPES = Object.keys(OBJECT_TYPES) as WorldObjectType[];

export function portsOf(type: WorldObjectType): readonly string[] {
  return OBJECT_TYPES[type].ports;
}
